module.exports = __webpack_public_path__ + "static/img/login-bg.65f77c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login-bg.png
// module id = gC88
// module chunks = 1